import { Button } from 'flowbite-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ErrorMessage } from '../ui';

export const AuthError = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const error = location.state?.error || 'Произошла ошибка авторизации';

  const handleBack = () => {
    navigate('/auth/ecp');
  };

  return (
    <div className="font-inter flex w-full flex-col items-center gap-6 pb-10 text-center leading-[normal] px-4">
      <ErrorMessage title={error} />

      <Button color="primary" onClick={handleBack}>
        Попробовать снова
      </Button>
    </div>
  );
};
